"use client";
const getElementsArray = (element, prefix) => {
  const baseSelector = `.${prefix}list-view-item:not(.${prefix}list-view-item--disabled)`;
  return Array.from(
    element.querySelectorAll(
      `${baseSelector} a, ${baseSelector} button, ${baseSelector} input, [role="option"]:not(.${prefix}menu-item--disabled)`
    )
  );
};
const handleKeyDown = (ev, prefix) => {
  if (["ArrowUp", "ArrowDown", "Home", "End", "Enter", " "].includes(ev.key)) {
    ev.preventDefault();
    const elements = getElementsArray(ev.currentTarget, prefix);
    const currentIndex = elements.indexOf(ev.target);
    let targetElement;
    switch (ev.key) {
      case "ArrowUp":
        targetElement = elements[Math.max(Math.min(currentIndex - 1, elements.length - 1), 0)];
        break;
      case "ArrowDown":
        targetElement = elements[Math.max(Math.min(currentIndex + 1, elements.length - 1), 0)];
        break;
      case "Home":
        targetElement = elements[0];
        break;
      case "End":
        targetElement = elements[elements.length - 1];
        break;
      case "Enter":
      case " ":
        ev.preventDefault();
        ev.target.click();
        break;
      default:
        break;
    }
    targetElement?.focus();
  }
};
var handleKeyDown_default = handleKeyDown;
export {
  handleKeyDown_default as default,
  getElementsArray
};
